import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  FormGroup,
  FormControl,
  Alert,
  Stack,
  Container,
  Backdrop,
  CircularProgress,
  InputLabel,
  IconButton,
  Typography,
  Grid,
  Paper,
} from "@material-ui/core";
import axios from "axios";
import { CartContext } from '../CartContext/CartContext';
import Cookies from "universal-cookie";
import HomePage2 from "../HomePage2/HomePage2";
import { config } from "../../config/config";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import StorefrontIcon from '@material-ui/icons/Storefront';
import BusinessIcon from '@material-ui/icons/Business';
import BuildIcon from '@material-ui/icons/Build';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

const cookies = new Cookies();

export default function Login() {
  const cartContext = useContext(CartContext);
  const { setUser } = cartContext;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, setLogin] = useState(false);
  const [loginFail, setLoginFail] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const handleClose = () => setOpen(false);

  const token = cookies.get("token");
  let navigate = useNavigate();

  const performLogin = (targetEmail, targetPassword) => {
    setOpen(true);
    const configuration = {
      method: "post",
      url: `${config.SERVER}/login`,
      data: {
        email: targetEmail,
        password: targetPassword,
      },
    };

    axios(configuration)
      .then((result) => {
        setLogin(true);
        setUser(cookies.get("user"));
        cookies.set("token", result.data.token, { path: "/" });
        cookies.set("user", result.data.email, { path: "/" });
        cookies.set("IdVendedor", result.data.IdVendedor, { path: "/" });
        setOpen(false);
        window.location.href = "/";
      })
      .catch((error) => {
        setMessage(error.response?.data?.message || "Error al autenticar");
        setLoginFail(true);
        setOpen(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    performLogin(email, password);
  };

  const handleQuickLogin = (demoEmail, demoPassword) => {
    setEmail(demoEmail);
    setPassword(demoPassword);
    performLogin(demoEmail, demoPassword);
  };

  return (
    <>
      {token ? (
        <HomePage2 />
      ) : (
        <Container maxWidth="sm" style={{ marginTop: "20px", marginBottom: "40px" }}>
          <Typography variant="h4" align="center" gutterBottom style={{ fontWeight: 700, color: "#1976d2" }}>
            Portal Mayorista B2B
          </Typography>
          <Typography variant="body2" align="center" color="textSecondary" style={{ marginBottom: "20px" }}>
            Ingresá a tu cuenta para ver tus listas de precios personalizadas y condiciones comerciales.
          </Typography>

          {/* Selector de Cuentas de Demostración */}
          <Paper elevation={3} style={{ padding: "18px", marginBottom: "24px", backgroundColor: "#f8fafd", border: "1px solid #bbdefb", borderRadius: "12px" }}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#0d47a1", marginBottom: "12px", textAlign: "center" }}>
              🎯 Probar Demo en Vivo (Acceso con 1 Clic):
            </Typography>
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<BusinessIcon style={{ color: "#1565c0" }} />}
                  style={{ textTransform: "none", borderColor: "#90caf9", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("mayorista1@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Mayorista Platino</Typography>
                    <Typography variant="caption" style={{ color: "#2e7d32", fontWeight: 700 }}>Descuento 20%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<StorefrontIcon style={{ color: "#0288d1" }} />}
                  style={{ textTransform: "none", borderColor: "#90caf9", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("mayorista2@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Distribuidor Litoral</Typography>
                    <Typography variant="caption" style={{ color: "#1565c0", fontWeight: 700 }}>Descuento 15%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<BuildIcon style={{ color: "#e65100" }} />}
                  style={{ textTransform: "none", borderColor: "#90caf9", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("gremio@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Cliente Gremio / Taller</Typography>
                    <Typography variant="caption" style={{ color: "#e65100", fontWeight: 700 }}>Descuento 10%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<SupervisorAccountIcon style={{ color: "#6a1b9a" }} />}
                  style={{ textTransform: "none", borderColor: "#ce93d8", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("admin@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Administrador</Typography>
                    <Typography variant="caption" style={{ color: "#6a1b9a", fontWeight: 700 }}>Panel de Control</Typography>
                  </Box>
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {/* Formulario tradicional */}
          <Paper elevation={1} style={{ padding: "24px", borderRadius: "12px" }}>
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <FormControl fullWidth style={{ marginBottom: "16px" }}>
                  <TextField
                    id="login-email"
                    label="Correo Electrónico"
                    name="email"
                    type="email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormControl variant="outlined" fullWidth style={{ marginBottom: "20px" }}>
                  <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Contraseña"
                    required
                  />
                </FormControl>
              </FormGroup>

              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                type="submit"
                style={{ padding: "10px", fontWeight: "bold", borderRadius: "8px" }}
              >
                Ingresar al Catálogo
              </Button>

              <Stack style={{ width: "100%", marginTop: "16px" }} spacing={2}>
                {login && <Alert severity="success">Autenticación Correcta</Alert>}
                {loginFail && <Alert severity="error">{message || "Error de autenticación"}</Alert>}
              </Stack>
            </form>
          </Paper>
        </Container>
      )}
      <Backdrop
        style={{ color: '#fff', zIndex: 9999 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
